import React, { useState } from 'react';
import { Copy, Check, Eye } from 'lucide-react';
import { generateShareUrl } from '../utils/shareUtils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { Input } from './ui/input';

const ShareDialog = ({ params, isPanel = false, onPreview }) => {
  const [caption, setCaption] = useState('');
  const [copied, setCopied] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const shareUrl = generateShareUrl(params, caption);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handlePreview = () => {
    navigator.clipboard.writeText(shareUrl);
    setDialogOpen(false);
    onPreview?.(shareUrl);
  };

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="btn-share"
          className={isPanel
            ? "w-full px-4 py-2 text-[10px] uppercase tracking-[0.15em] border border-[#00F0FF]/50 text-[#00F0FF] hover:border-[#00F0FF]/80 hover:bg-[#00F0FF]/10 transition-all duration-150 rounded"
            : "flex items-center gap-1.5 px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-gray-700 text-gray-400 hover:border-[#00F0FF]/50 hover:text-[#00F0FF] transition-all duration-150"
          }
        >
          Share
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg bg-[#06090e]/95 border border-[#00F0FF]/20">
        <DialogHeader>
          <DialogTitle className="text-[#00F0FF]">Sharo boobs</DialogTitle>
          <DialogDescription className="text-gray-400">
            Add a short caption and share your creation
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="caption" className="text-[10px] uppercase tracking-[0.18em] text-gray-400">
              Caption (optional)
            </label>
            <Input
              id="caption"
              placeholder="e.g., My favorite look..."
              value={caption}
              onChange={(e) => {
                const filtered = e.target.value.replace(/[^a-zA-Zа-яА-ЯёЁ0-9 !?,\.=\)\(;:\-]/g, '');
                setCaption(filtered);
              }}
              maxLength={50}
              className="bg-[#030405] border-[#00F0FF]/20 text-white placeholder-gray-600"
            />
            <span className="text-[8px] text-gray-600">{caption.length}/50</span>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[10px] uppercase tracking-[0.18em] text-gray-400">Share Link</label>
            <div className="flex gap-2">
              <input
                type="text"
                value={shareUrl}
                readOnly
                className="flex-1 px-3 py-2 bg-[#030405] border border-[#00F0FF]/20 text-white text-[10px] font-mono rounded truncate"
              />
              <button
                onClick={handleCopy}
                className="px-3 py-2 bg-[#00F0FF]/20 border border-[#00F0FF]/40 text-[#00F0FF] hover:bg-[#00F0FF]/30 transition-colors rounded flex items-center gap-1"
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
              </button>
            </div>
            <p className="text-[8px] text-gray-600">
              {copied ? '✓ Copied to clipboard!' : 'Click to copy link'}
            </p>
          </div>

          <button
            onClick={handlePreview}
            className="flex items-center justify-center gap-2 w-full px-4 py-2 text-[10px] uppercase tracking-[0.18em] border border-[#00F0FF]/40 text-[#00F0FF] hover:bg-[#00F0FF]/10 hover:border-[#00F0FF]/70 transition-all duration-150"
          >
            <Eye size={12} /> Preview
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
